import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const uploadFile = async (file) => {
  const data = new FormData();
  data.append("file", file);
  const res = await axios.post(`${API}/upload`, data, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  // Backend returns a relative url; prepend the public backend URL so links
  // (used in notification emails) resolve correctly in any environment.
  const absoluteUrl = res.data.url?.startsWith("http")
    ? res.data.url
    : `${BACKEND_URL}${res.data.url}`;
  return { ...res.data, url: absoluteUrl }; // { id, url, filename, path }
};

export const submitQuote = async (payload) => {
  const res = await axios.post(`${API}/quote`, payload, { timeout: 30000 });
  return res.data;
};

export const submitContact = async (payload) => {
  const res = await axios.post(`${API}/contact`, payload, { timeout: 30000 });
  return res.data;
};

export const submitCareer = async (payload) => {
  const res = await axios.post(`${API}/careers`, payload, { timeout: 30000 });
  return res.data;
};
